import { Generic } from './Image';
export function isImage(node) {
    return node !== null && typeof node === 'object' && node instanceof Generic;
}
export default isImage;    //# sourceMappingURL=isImage.js.map
